export default [
  {
    title: 'เช็คสถานะ',
    route: 'customer-shipping-status',
    icon: 'MapPinIcon',
    resource: 'normal',
    action: 'manage',
  },
  {
    title: 'บิลค่าขนส่ง',
    route: 'customer-shipping-delivery',
    icon: 'FileTextIcon',
    resource: 'normal',
    action: 'manage',
  },
  {
    title: 'วิธีการสั่งของ',
    route: 'customer-shipping-howtoorder',
    icon: 'BookOpenIcon',
    resource: 'normal',
    action: 'manage',
  },
]
